// Example: src/example.test.js
test('Basic test to verify setup', () => {
    expect(2 + 2).toBe(4);
});